const base = import.meta.env.BASE_URL;

export function RoutingVisual() {
  return <div className="service-demo routing-demo" aria-hidden="true">
    <span className="demo-caption">Enquiry → action</span>
    <div className="demo-message"><img src={`${base}logos/gmail.svg`} alt="" /><div><b>New enquiry</b><span>Ready to route</span></div></div>
    <div className="demo-connector"><i /></div>
    <div className="demo-rule">Assign &amp; follow up</div>
    <div className="demo-connector"><i /></div>
    <div className="demo-destinations"><span><img src={`${base}logos/hubspot.svg`} alt="" />CRM <i>✓</i></span><span><img src={`${base}logos/slack.svg`} alt="" />Team <i>✓</i></span></div>
  </div>;
}

export function AiVisual() {
  return <div className="service-demo extraction-demo" aria-hidden="true">
    <span className="demo-caption">Document → review</span>
    <div className="demo-document"><span>Incoming document</span><b>Invoice</b><div className="demo-document-lines"><i /><i /><i /></div><div className="demo-scan" /></div>
    <div className="demo-extraction"><span>Details extracted <i>✓</i></span><b>Ready for human review</b></div>
  </div>;
}

export function ProcessVisual() {
  return <div className="service-demo approvals-demo" aria-hidden="true">
    <span className="demo-caption">Request → approval</span>
    <div className="demo-request"><span>Purchase request</span><b>Assigned to operations</b></div>
    <ol className="demo-approval-steps">{['Request received', 'Owner reviews', 'Approved to proceed'].map((step, index) => <li key={step} style={{ animationDelay: `${index * 2}s` }}><span>{index === 2 ? '✓' : index + 1}</span><b>{step}</b></li>)}</ol>
  </div>;
}

export function AppVisual() {
  return <div className="service-demo app-demo" aria-hidden="true">
    <span className="demo-caption">Your process → your app</span>
    <div className="demo-app-window"><div className="demo-app-header"><span className="demo-app-mark">A</span><b>Team workspace</b><span>↗</span></div>
      <div className="demo-app-body"><div className="demo-app-sidebar"><i /><i /><i /></div><div className="demo-app-content"><b>Requests</b><div className="demo-app-row"><span>New enquiry</span><i>Assign</i></div><div className="demo-app-row"><span>Purchase request</span><i>Review</i></div><div className="demo-app-row"><span>Team handover</span><i>Ready ✓</i></div></div></div>
    </div><div className="demo-app-footer"><span>Dashboard</span><span>Portal</span><span>Internal tool</span></div>
  </div>;
}
